import { Route } from '@angular/router';

export const SCHEDULE_ROUTES: Route[] = [
  { path: '', loadComponent: () => import('./components/schedule/schedule.component').then(m => m.ScheduleComponent) }
];
